export const GOOGLE_MAPS_API_KEY = "AIzaSyBlYXWB8YJ8D6CG7CpMA5yu9n813oIcQRg";//TODO Provide api key for production.

export const DEDICATED_DB_FEATURE_CODE = "Dedicated_DB";
export const MESSAGES = {
    CHANGES_SAVE_SUCCESS: 'Changes Saved Successfully.',
    CHANGES_SAVE_ERROR: 'Error Saving Changes',
    FILL_REQUIRED_FIELDS: "Please fill in required fields.",
}
export const MONTH_LIST =  ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];